<template>
  <div class="svgcurves">
      
              <!-- 新增修改 -->
                <el-dialog v-dialogDrag :title="deviceName +' 实时曲线'" :close-on-click-modal='false' :visible.sync="newdialogVisible"
                    width="90%" center>
                        <div class="zhongf">
                         <createNode @closeSvg='closeSvg' :newdialogVisible="newdialogVisible" ></createNode>
                        </div>
                    </el-dialog>
    
  </div>
</template>

<script>
import createNode from '@/page/rtvalue/newvirtualDeviceRTCurve.vue'; //通用
// import createNode from '@/page/rtvalue/deviceRTCurveCopy.vue'; // 天津德源
export default {
     components: {
    createNode,
 },
 props: {
			dialogVisible: {
				type: Boolean
				},
            deviceName:{
                type: String
            }
		},
        watch:{
            dialogVisible(val){
                this.newdialogVisible = val
                this.$store.deviceStore.commit('saveDeviceName',this.deviceName)
            },
            newdialogVisible(val){
                //通用
                   if(!val){
                      setTimeout(() => {
                          this.$emit('dialogVisible_fn',this.myDeviceList)
                      },500)
                   }
                   //天津德源
                    // this.$emit('dialogVisible_fn') 
            }

        },
   data() {
      return {
          newdialogVisible:false,
          myDeviceList:[]
        
      }
    },
    methods:{
        //通用
        closeSvg(val){
            this.myDeviceList = val
        }
    }
}
</script>

<style scoped lang="scss">
   .svgcurves {
     position: absolute;
     top: 0%;
     color: #fff;
     width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/.el-dialog__wrapper {
        position: absolute !important; 
    }
   }
</style>